import { NuxtCookies } from 'cookie-universal-nuxt';
import { Context } from '@vsf-enterprise/sapcc';
import { USER_COOKIE_NAME, ANONYMOUS_USER } from '@vsf-enterprise/sapcc-api';
import { CART_USER } from './constants';

export const anonymousCartUtils = ({
  $cookies,
  $vsf
}: {
  $cookies: NuxtCookies;
  $vsf: Context;
}) => {
  return {
    anonymousCartRoutes: ['Checkout/Email'],

    getCart: async () =>
      await $vsf.$sapcc.api.createCart({
        userId: $cookies.get(USER_COOKIE_NAME)
      }),

    isCartUserAnonymous: () => $cookies.get(CART_USER).uid === ANONYMOUS_USER,

    isCartUserCookieExist: () => Boolean($cookies.get(CART_USER))
  };
};
